import { render, staticRenderFns } from "./Pdv.vue?vue&type=template&id=027d302e"
import script from "./Pdv.vue?vue&type=script&lang=js"
export * from "./Pdv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports